function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { hasProperty, lastItemOf, isInRange, limitToRange } from '../lib/utils.js';
import { today } from '../lib/date.js';
import { parseHTML, getParent, showElement, hideElement, emptyChildNodes } from '../lib/dom.js';
import { registerListeners } from '../lib/event.js';
import pickerTemplate from './templates/pickerTemplate.js';
import DaysView from './views/DaysView.js';
import MonthsView from './views/MonthsView.js';
import YearsView from './views/YearsView.js';
import { triggerDatepickerEvent } from '../events/functions.js';
import { onClickTodayBtn, onClickClearBtn, onClickViewSwitch, onClickPrevBtn, onClickNextBtn, onClickView, onMousedownPicker } from '../events/pickerListeners.js';
var orientClasses = ['left', 'top', 'right', 'bottom'].reduce(function (obj, key) {
  obj[key] = "datepicker-orient-".concat(key);
  return obj;
}, {});

var toPx = function toPx(num) {
  return num ? "".concat(num, "px") : num;
};

function processPickerOptions(picker, options) {
  if (options.title !== undefined) {
    if (options.title) {
      picker.controls.title.textContent = options.title;
      showElement(picker.controls.title);
    } else {
      picker.controls.title.textContent = '';
      hideElement(picker.controls.title);
    }
  }

  if (options.prevArrow) {
    var prevBtn = picker.controls.prevBtn;
    emptyChildNodes(prevBtn);
    options.prevArrow.forEach(function (node) {
      prevBtn.appendChild(node.cloneNode(true));
    });
  }

  if (options.nextArrow) {
    var nextBtn = picker.controls.nextBtn;
    emptyChildNodes(nextBtn);
    options.nextArrow.forEach(function (node) {
      nextBtn.appendChild(node.cloneNode(true));
    });
  }

  if (options.locale) {
    picker.controls.todayBtn.textContent = options.locale.today;
    picker.controls.clearBtn.textContent = options.locale.clear;
  }

  if (options.todayBtn !== undefined) {
    if (options.todayBtn) {
      showElement(picker.controls.todayBtn);
    } else {
      hideElement(picker.controls.todayBtn);
    }
  }

  if (hasProperty(options, 'minDate') || hasProperty(options, 'maxDate')) {
    var _picker$datepicker$co = picker.datepicker.config,
        minDate = _picker$datepicker$co.minDate,
        maxDate = _picker$datepicker$co.maxDate;
    picker.controls.todayBtn.disabled = !isInRange(today(), minDate, maxDate);
  }

  if (options.clearBtn !== undefined) {
    if (options.clearBtn) {
      showElement(picker.controls.clearBtn);
    } else {
      hideElement(picker.controls.clearBtn);
    }
  }
} // Compute view date to reset, which will be...
// - the last item of the selected dates or defaultViewDate if no selection
// - limitted to minDate or maxDate if it exceeds the range


function computeResetViewDate(datepicker) {
  var dates = datepicker.dates,
      config = datepicker.config;
  var viewDate = dates.length > 0 ? lastItemOf(dates) : config.defaultViewDate;
  return limitToRange(viewDate, config.minDate, config.maxDate);
} // Change current view's view date


function setViewDate(picker, newDate) {
  var oldViewDate = new Date(picker.viewDate);
  var newViewDate = new Date(newDate);
  var _picker$currentView = picker.currentView,
      id = _picker$currentView.id,
      year = _picker$currentView.year,
      first = _picker$currentView.first,
      last = _picker$currentView.last;
  var viewYear = newViewDate.getFullYear();
  picker.viewDate = newDate;

  if (viewYear !== oldViewDate.getFullYear()) {
    triggerDatepickerEvent(picker.datepicker, 'changeYear');
  }

  if (newViewDate.getMonth() !== oldViewDate.getMonth()) {
    triggerDatepickerEvent(picker.datepicker, 'changeMonth');
  } // return whether the new date is in different period on time from the one
  // displayed in the current view
  // when true, the view needs to be re-rendered on the next UI refresh.


  switch (id) {
    case 0:
      return newDate < first || newDate > last;

    case 1:
      return viewYear !== year;

    default:
      return viewYear < first || viewYear > last;
  }
}

function getTextDirection(el) {
  return window.getComputedStyle(el).direction;
} // find the closet scrollable ancestor elemnt under the body


function findScrollParents(el) {
  var parent = getParent(el);

  if (parent === document.body || !parent) {
    return;
  } // checking overflow only is enough because computed overflow cannot be
  // visible or a combination of visible and other when either axis is set
  // to other than visible.
  // (Setting one axis to other than 'visible' while the other is 'visible'
  // results in the other axis turning to 'auto')


  return window.getComputedStyle(parent).overflow !== 'visible' ? parent : findScrollParents(parent);
} // Class representing the picker UI


var Picker = /*#__PURE__*/function () {
  function Picker(datepicker) {
    _classCallCheck(this, Picker);

    var _this$datepicker = this.datepicker = datepicker,
        config = _this$datepicker.config;

    var template = pickerTemplate.replace(/%buttonClass%/g, config.buttonClass);
    var element = this.element = parseHTML(template).firstChild;

    var _element$firstChild$c = _slicedToArray(element.firstChild.children, 3),
        header = _element$firstChild$c[0],
        main = _element$firstChild$c[1],
        footer = _element$firstChild$c[2];

    var title = header.firstElementChild;

    var _header$lastElementCh = _slicedToArray(header.lastElementChild.children, 3),
        prevBtn = _header$lastElementCh[0],
        viewSwitch = _header$lastElementCh[1],
        nextBtn = _header$lastElementCh[2];

    var _footer$firstChild$ch = _slicedToArray(footer.firstChild.children, 2),
        todayBtn = _footer$firstChild$ch[0],
        clearBtn = _footer$firstChild$ch[1];

    var controls = {
      title: title,
      prevBtn: prevBtn,
      viewSwitch: viewSwitch,
      nextBtn: nextBtn,
      todayBtn: todayBtn,
      clearBtn: clearBtn
    };
    this.main = main;
    this.controls = controls;
    var elementClass = datepicker.inline ? 'inline' : 'dropdown';
    element.classList.add("datepicker-".concat(elementClass));
    processPickerOptions(this, config);
    this.viewDate = computeResetViewDate(datepicker); // set up event listeners

    registerListeners(datepicker, [[element, 'mousedown', onMousedownPicker], [main, 'click', onClickView.bind(null, datepicker)], [controls.viewSwitch, 'click', onClickViewSwitch.bind(null, datepicker)], [controls.prevBtn, 'click', onClickPrevBtn.bind(null, datepicker)], [controls.nextBtn, 'click', onClickNextBtn.bind(null, datepicker)], [controls.todayBtn, 'click', onClickTodayBtn.bind(null, datepicker)], [controls.clearBtn, 'click', onClickClearBtn.bind(null, datepicker)]]); // set up views

    this.views = [new DaysView(this), new MonthsView(this), new YearsView(this, {
      id: 2,
      name: 'years',
      cellClass: 'year',
      step: 1
    }), new YearsView(this, {
      id: 3,
      name: 'decades',
      cellClass: 'decade',
      step: 10
    })];
    this.currentView = this.views[config.startView];
    this.currentView.render();
    this.main.appendChild(this.currentView.element);

    if (config.container) {
      config.container.appendChild(this.element);
    } else {
      datepicker.inputField.after(this.element);
    }
  }

  _createClass(Picker, [{
    key: "setOptions",
    value: function setOptions(options) {
      processPickerOptions(this, options);
      this.views.forEach(function (view) {
        view.init(options, false);
      });
      this.currentView.render();
    }
  }, {
    key: "detach",
    value: function detach() {
      this.element.remove();
    }
  }, {
    key: "show",
    value: function show() {
      if (this.active) {
        return;
      }

      var datepicker = this.datepicker,
          element = this.element;

      if (datepicker.inline) {
        element.classList.add('active');
      } else {
        // ensure picker's direction matches input's
        var inputDirection = getTextDirection(datepicker.inputField);

        if (inputDirection !== getTextDirection(getParent(element))) {
          element.dir = inputDirection;
        } else if (element.dir) {
          element.removeAttribute('dir');
        }

        element.style.visiblity = 'hidden';
        element.classList.add('active');
        this.place();
        element.style.visiblity = '';

        if (datepicker.config.disableTouchKeyboard) {
          datepicker.inputField.blur();
        }
      }

      this.active = true;
      triggerDatepickerEvent(datepicker, 'show');
    }
  }, {
    key: "hide",
    value: function hide() {
      if (!this.active) {
        return;
      }

      this.datepicker.exitEditMode();
      this.element.classList.remove('active');
      this.active = false;
      triggerDatepickerEvent(this.datepicker, 'hide');
    }
  }, {
    key: "place",
    value: function place() {
      var _this$element = this.element,
          classList = _this$element.classList,
          offsetParent = _this$element.offsetParent,
          style = _this$element.style;
      var _this$datepicker2 = this.datepicker,
          config = _this$datepicker2.config,
          inputField = _this$datepicker2.inputField;

      var _this$element$getBoun = this.element.getBoundingClientRect(),
          calendarWidth = _this$element$getBoun.width,
          calendarHeight = _this$element$getBoun.height;

      var _inputField$getBoundi = inputField.getBoundingClientRect(),
          inputLeft = _inputField$getBoundi.left,
          inputTop = _inputField$getBoundi.top,
          inputRight = _inputField$getBoundi.right,
          inputBottom = _inputField$getBoundi.bottom,
          inputWidth = _inputField$getBoundi.width,
          inputHeight = _inputField$getBoundi.height;

      var _config$orientation = config.orientation,
          orientX = _config$orientation.x,
          orientY = _config$orientation.y;
      var left = inputLeft;
      var top = inputTop; // caliculate offsetLeft/Top of inputField

      if (offsetParent === document.body || !offsetParent) {
        left += window.scrollX;
        top += window.scrollY;
      } else {
        var offsetParentRect = offsetParent.getBoundingClientRect();
        left -= offsetParentRect.left - offsetParent.scrollLeft;
        top -= offsetParentRect.top - offsetParent.scrollTop;
      } // caliculate the boundaries of the visible area that contains inputField


      var scrollParent = findScrollParents(inputField);
      var scrollAreaLeft = 0;
      var scrollAreaTop = 0;
      var _document$documentEle = document.documentElement,
          scrollAreaRight = _document$documentEle.clientWidth,
          scrollAreaBottom = _document$documentEle.clientHeight;

      if (scrollParent) {
        var scrollParentRect = scrollParent.getBoundingClientRect();

        if (scrollParentRect.top > 0) {
          scrollAreaTop = scrollParentRect.top;
        }

        if (scrollParentRect.left > 0) {
          scrollAreaLeft = scrollParentRect.left;
        }

        if (scrollParentRect.right < scrollAreaRight) {
          scrollAreaRight = scrollParentRect.right;
        }

        if (scrollParentRect.bottom < scrollAreaBottom) {
          scrollAreaBottom = scrollParentRect.bottom;
        }
      } // determine the horizontal orientation and left position


      var adjustment = 0;

      if (orientX === 'auto') {
        if (inputLeft < scrollAreaLeft) {
          orientX = 'left';
          adjustment = scrollAreaLeft - inputLeft;
        } else if (inputLeft + calendarWidth > scrollAreaRight) {
          orientX = 'right';

          if (scrollAreaRight < inputRight) {
            adjustment = scrollAreaRight - inputRight;
          }
        } else if (getTextDirection(inputField) === 'rtl') {
          orientX = inputRight - calendarWidth < scrollAreaLeft ? 'left' : 'right';
        } else {
          orientX = 'left';
        }
      }

      if (orientX === 'right') {
        left += inputWidth - calendarWidth;
      }

      left += adjustment; // determine the vertical orientation and top position

      if (orientY === 'auto') {
        if (inputTop - calendarHeight > scrollAreaTop) {
          orientY = inputBottom + calendarHeight > scrollAreaBottom ? 'top' : 'bottom';
        } else {
          orientY = 'bottom';
        }
      }

      if (orientY === 'top') {
        top -= calendarHeight;
      } else {
        top += inputHeight;
      }

      classList.remove.apply(classList, _toConsumableArray(Object.values(orientClasses)));
      classList.add(orientClasses[orientX], orientClasses[orientY]);
      style.left = toPx(left);
      style.top = toPx(top);
    }
  }, {
    key: "setViewSwitchLabel",
    value: function setViewSwitchLabel(labelText) {
      this.controls.viewSwitch.textContent = labelText;
    }
  }, {
    key: "setPrevBtnDisabled",
    value: function setPrevBtnDisabled(disabled) {
      this.controls.prevBtn.disabled = disabled;
    }
  }, {
    key: "setNextBtnDisabled",
    value: function setNextBtnDisabled(disabled) {
      this.controls.nextBtn.disabled = disabled;
    }
  }, {
    key: "changeView",
    value: function changeView(viewId) {
      var oldView = this.currentView;
      var newView = this.views[viewId];

      if (newView.id !== oldView.id) {
        this.currentView = newView;
        this._renderMethod = 'render';
        triggerDatepickerEvent(this.datepicker, 'changeView');
        this.main.replaceChild(newView.element, oldView.element);
      }

      return this;
    } // Change the focused date (view date)

  }, {
    key: "changeFocus",
    value: function changeFocus(newViewDate) {
      this._renderMethod = setViewDate(this, newViewDate) ? 'render' : 'refreshFocus';
      this.views.forEach(function (view) {
        view.updateFocus();
      });
      return this;
    } // Apply the change of the selected dates

  }, {
    key: "update",
    value: function update() {
      var newViewDate = computeResetViewDate(this.datepicker);
      this._renderMethod = setViewDate(this, newViewDate) ? 'render' : 'refresh';
      this.views.forEach(function (view) {
        view.updateFocus();
        view.updateSelection();
      });
      return this;
    } // Refresh the picker UI

  }, {
    key: "render",
    value: function render() {
      var quickRender = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var renderMethod = quickRender && this._renderMethod || 'render';
      delete this._renderMethod;
      this.currentView[renderMethod]();
    }
  }]);

  return Picker;
}();

export { Picker as default };